import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledDiv = styled.div`
    text-align: center;
    background: ${(props) => (props.replacementNames ? '#000000' : 'transparent')};
    display: inline-block;
    padding: 0.2rem 0.5rem;
    margin-top: 0.7rem;
    color: #f1bf6f;
    font-size: 0.5rem;
    border-radius: 1rem;
    text-transform: uppercase;
    top: -100%;
    padding-top: 0.3rem;
`;

function Replacement({ replacements }) {
    const { cardMetaData } = useFormTab();
    const { actions, powers } = cardMetaData;

    const replacementNames = hasReplacement(replacements, cardMetaData)
        ? getReplacementNames(actions, powers, replacements)
        : null;

    return (
        <StyledDiv
            className={'font-face-aAtmospheric position-relative '}
            replacementNames={replacementNames}
        >
            {replacementNames && (
                <>
                    <span style={{ color: '#fff' }}>Replaces </span> {replacementNames.join('/')}
                </>
            )}
        </StyledDiv>
    );
}

function hasReplacement(replacements, cardMetaData) {
    return replacements.length > 0 && !isEmpty(cardMetaData);
}

function getReplacementNames(actions, powers, replacements) {
    const options = [...actions, ...powers];
    const replacementNames = options.filter((option) => replacements.includes(option.id));
    replacementNames.forEach((item, i, arr) => {
        arr[i] = item.name.replace(/\s+/g, '');
    });

    return replacementNames;
}

Replacement.defaultProps = {
    replacements: [],
};
Replacement.propTypes = {
    replacements: PropTypes.array,
};

export default React.memo(Replacement);
